import { useLocation, useSearchParams, Navigate } from "react-router-dom";
import { Card, CopyButton } from "@jkast90/kast-common/ui";
import styles from "./CheckEmail.module.css";

const SUPPORT_EMAIL = "support@kast-dev.net";

export default function CheckEmail() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") || "";
  const email = location.state?.email;

  if (!email) {
    return <Navigate to={"/" + (redirect ? `?redirect=${encodeURIComponent(redirect)}` : "")} replace />;
  }

  return (
    <div className={styles.page}>
      <Card padding="lg" className={styles.card}>
        <img src="/kd_logo.png" alt="Kast Dev" className={styles.logo} />

        <div className={styles.iconWrapper}>
          <svg
            className={styles.icon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            aria-hidden="true"
            focusable="false"
            strokeWidth="1.5"
          >
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="M22 4L12 13L2 4" />
          </svg>
        </div>

        <h1 className={styles.title}>Check your email</h1>

        <p className={styles.message}>We've sent a verification link to</p>
        <p className={styles.email}>{email}</p>

        <p className={styles.instructions}>
          Click the link in the email to verify your account or wait for an admin to verify it. Once verified, you'll be
          able to sign in to Kast Dev.
        </p>

        <Card className={styles.tips}>
          <p className={styles.tipsTitle}>Didn't get the email?</p>
          <ul className={styles.tipsList}>
            <li>Check your spam or junk folder</li>
            <li>Make sure you entered the correct email</li>
            <li>The link expires in 24 hours</li>
            <li>
              If you don't get one, send an email to{" "}
              <a href={`mailto:${SUPPORT_EMAIL}`} className={styles.supportLink}>
                {SUPPORT_EMAIL}
              </a>
              <CopyButton text={SUPPORT_EMAIL} size="sm" timeoutMs={2000} className={styles.copyButton} />
            </li>
          </ul>
        </Card>

        <a href="/" className={styles.backLink}>
          Back to sign up
        </a>
      </Card>
    </div>
  );
}
